import Vue from 'vue'
import _axios from '@/plugins/axios'
import { AxiosInstance } from 'axios'

export const ResponseStatusCodes = {
  SUCCESS: 200,
  BAD_REQUEST_ERROR: 400,
  UNAUTHORIZED_ERROR: 401,
  FORBIDDEN_ERROR: 403,
  NOT_FOUND_ERROR: 404,
  SESSION_EXPIRED_ERROR: 419,
  UNPROCESSABLE_ENTITY_ERROR: 422,
  INTERNAL_SERVER_ERROR: 500
}

declare module 'vue/types/vue' {
  interface Vue {
    $responseStatusCodes: typeof ResponseStatusCodes;
  }
}
Vue.prototype.$responseStatusCodes = ResponseStatusCodes

export default class ApiService {
  protected static axios: AxiosInstance = _axios;
  protected static dataSource = process.env.VUE_APP_DATA_SOURCE
}
